import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { useLanguage } from "@/i18n/LanguageContext";
import api, { formatApiError, API_URL } from "@/lib/api";
import { useEffect } from "react";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const { t } = useLanguage();
  const [fbEnabled, setFbEnabled] = useState(false);
  useEffect(() => { api.get("/auth/facebook/config").then(r => setFbEnabled(r.data.enabled)).catch(() => {}); }, []);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const u = await login(email, password);
      toast.success(`Welcome back, ${u.name}`);
      nav(u.role === "seller" ? "/seller" : u.role === "buyer" ? "/buyer" : u.role === "admin" ? "/admin" : u.role === "service_provider" ? "/directory/me" : "/marketplace");
    } catch (err) {
      toast.error(formatApiError(err));
    } finally { setLoading(false); }
  };

  const googleLogin = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/marketplace";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="max-w-md mx-auto px-6 py-12">
      <div className="surface-card p-8">
        <h1 className="heading text-2xl font-bold">{t("login.title")}</h1>
        <p className="text-sm text-stone-500 mt-1">{t("login.subtitle")}</p>
        <form onSubmit={submit} className="mt-6 space-y-4">
          <div>
            <Label htmlFor="email">{t("login.email")}</Label>
            <Input data-testid="login-email-input" id="email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} />
          </div>
          <div>
            <Label htmlFor="password">{t("login.password")}</Label>
            <Input data-testid="login-password-input" id="password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} />
          </div>
          <Button data-testid="login-submit-btn" type="submit" disabled={loading} className="btn-forest w-full h-10">
            {loading ? "…" : t("login.submit")}
          </Button>
        </form>
        <div className="my-6 flex items-center gap-3 text-xs text-stone-400"><div className="flex-1 border-t" /> OR <div className="flex-1 border-t" /></div>
        <Button data-testid="login-google-btn" onClick={googleLogin} variant="outline" className="w-full h-10">{t("login.google")}</Button>
        {fbEnabled && (
          <Button data-testid="login-facebook-btn" variant="outline" className="w-full h-10 mt-2"
                  onClick={() => { window.location.href = `${API_URL}/auth/facebook/start`; }}>
            Continue with Facebook
          </Button>
        )}
        <p className="mt-6 text-sm text-stone-500 text-center">
          {t("login.new")} <Link to="/register" className="text-[color:var(--forest-deep)] font-semibold underline">{t("login.create")}</Link>
        </p>
      </div>
    </div>
  );
}
